export var ENTER_KEY = 'Enter';
export var DOWN_ARROW_KEY = 'ArrowDown';
export var UP_ARROW_KEY = 'ArrowUp';
export var LEFT_ARROW_KEY = 'ArrowLeft';
export var RIGHT_ARROW_KEY = 'ArrowRight';
